module.exports = __webpack_public_path__ + "img/product_1.531c7868.jpg";